if (!customElements.get('quick-filters')) {
  customElements.define(
    'quick-filters',
    class QuickFilters extends HTMLElement {
      constructor() {
        super();
        this.filters = this.querySelectorAll('[data-filter]');
        if (this.filters.length === 0) return;
      }

      get sectionID() {
        return this.dataset.sectionId;
      }

      get sliderShoudInit() {
        let itemsWidth = 0;
        this.filters.forEach((filter) => {
          itemsWidth += filter.offsetWidth;
        });

        return itemsWidth > this.clientWidth;
      }

      connectedCallback() {
        this.handleQuickFilters();
        this.handlePopState();
        this.initSlider();
      }

      initSlider() {
        if (!this.sliderShoudInit) return;
        const options = {
          slidesPerMove: 1,
          grabCursor: true,
          slidesPerView: 'auto',
          noSwiping: true,
          noSwipingClass: 'swiper-no-swiping',
          mousewheel: {
            forceToAxis: true,
          },
        };

        const swiper = new Swiper(this, options);
        this.setActivePosition(swiper);
      }

      handleQuickFilters() {
        this.filters.forEach((filter) => {
          filter.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.getCollectionHTML(filter);
          });
        });
      }

      async getCollectionHTML(filter) {
        if (filter.classList.contains('active')) return;
        try {
          this.filters.forEach((filter) => filter.classList.remove('active'));
          this.setWidthForPreloaded(filter, true);
          filter.classList.add('loading');
          const urlContainer = filter.querySelector('a');
          if (!urlContainer) return;
          const url = urlContainer.href.split('?')[0];
          if (!url) return;
          const response = await fetch(url);
          const result = await response.text();
          const HTML = new DOMParser().parseFromString(result, 'text/html');
          const collectionContainer = document.querySelector(`#${this.sectionID}`);
          const newCollectionContainer = HTML.querySelector(`#${this.sectionID}`);
          this.getSectionsToRerender().forEach((selector) => {
            const oldSection = collectionContainer.querySelector(selector);
            const newSection = newCollectionContainer.querySelector(selector);
            if (oldSection && newSection) {
              oldSection.outerHTML = newSection.outerHTML;
            }
          });
          this.onUpdatedFinished(url, filter, newCollectionContainer, collectionContainer);
        } catch (error) {
          console.error(error);
        }
      }

      handlePopState() {
        window.addEventListener('popstate', () => {
          const url = document.location.href;
          this.getCollectionHTML(url);
        });
      }

      setActivePosition(swiper) {
        let slideIndex = 0;
        let element = null;
        this.filters.forEach((filter, index) => {
          if (filter.classList.contains('active')) {
            slideIndex = index;
            element = filter;
          }
        });
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) {
              swiper.slideTo(slideIndex);
              observer.unobserve();
            }
          });
        });

        observer.observe(element);
      }

      setWidthForPreloaded(button, set) {
        const width = button.offsetWidth;
        set ? (button.style.width = `${width}px`) : button.removeAttribute('style');
      }

      setScrollPosition() {
        const currentScrollposition = window.scrollY;
        window.scrollTo({
          top: currentScrollposition,
          behavior: 'instant',
        });
      }

      onUpdatedFinished(url, filter, newCollectionContainer, collectionContainer) {
        const grid = newCollectionContainer.querySelector('[data-collection-grid]');
        if (grid) {
          grid.classList.add('animated-opacity');
        }
        filter.classList.remove('loading');
        filter.classList.add('active');
        this.setWidthForPreloaded(filter, false);

        this.setScrollPosition();
        history.pushState({}, '', url);
        collectionContainer.classList.remove('animated-opacity');
      }

      getSectionsToRerender() {
        return ['facets-component', '[data-collection-container]'];
      }
    }
  );
}
